<template>
  <div id="app">
    <!-- <Nav></Nav> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style>
b-img {
  display: block;
  width: 100%;
  height: auto;
}
#app {
  background-color: #f0efed;
  padding: 50px 0;
}
.column1 {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.row1 {
  display: flex;
  flex-direction: row;
  justify-content: start;
}
</style>
